import { render, staticRenderFns } from "./VentanaOperacionesVentanas.vue?vue&type=template&id=66baec0c"
import script from "./VentanaOperacionesVentanas.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesVentanas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports